<template>
  <h2>Not Found</h2>
</template>

<script>
export default {
  name: "NotFoundComponent",
  data() {
    return {

    }
  }
}
</script>

<style>

</style>